import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pagamento-ok',
  templateUrl: './pagamento-ok.component.html',
  styleUrls: ['./pagamento-ok.component.css']
})
export class PagamentoOkComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }


  btnTornaAllaDashboard() {
    this.router.navigate(['/dashboard/']);
  }


}
